import React from 'react';
import FeatureCard from './FeatureCard';
import './featuresection.css';
import android from "./images/androidfine.gif"
import location from "./images/EV.gif";
import music from "./images/music.gif";
import redtv from "./images/redtv.gif"
import soon from "./images/MOBILE.gif"
import iphone from "./images/iphone.gif"
 import ac from "./images/air-conditioner.gif"

const features = [
    {
        image: android,
        title: 'Android Finance Locker',
        description: 'Your finances. One secure ecosystem. Complete control. A powerful Android application designed to centralize your EMIs, bills, and dues in one intelligent interface.',
        link: '/products/android-finance-locker',
    },
    {
        image: iphone,
        title: 'IMac Finance Locker',
        description: 'Smart finance, refined for the Apple ecosystem. An intuitive macOS solution that enables seamless management of EMIs and expenses. Crafted for productivity, clarity, and effortless control—finance that fits naturally into your workflow.',
        link: '/products/imac-finance-locker',
    },
    {
        image: redtv,
        title: 'TV',
        description: 'Stunning visuals. Immersive sound. Complete control. A refined smart TV experience delivering Ultra HD clarity, Dolby Audio, and seamless connectivity—crafted for are fined home entertainment experience.',
        link: '/products/led-tv',
    },
  {
  image: ac,
  title: 'AC',
  description: 'Stunning visuals. Immersive sound. Complete control. A refined smart TV experience delivering Ultra HD clarity, Dolby Audio, and seamless connectivity—crafted for are fined home entertainment experience.',
  link: '/products/air-conditioner',
},

    {
        image: location,
        title: 'EV',
        description: 'Mobility redefined. Clean, quiet, and intelligent. Red Wolf EVs deliver effortless electric driving designed for everyday life and evolving urban journeys.',
        link: '/products/ev',
    },
   {
  image: soon,
  title: 'Red Wolf Nationx Accessories ',
  description: 'Everyday essentials, refined. Thoughtfully designed for comfort, durability, and style, Red Wolf Nationx mobile accessories elevate how you connect, work, and move—every single day.',
  link: '/products/coming-soon',
},

];

const FeatureSection = () => {
    return (
        <section className="features-section">
            <div className="container">
                <div className="section-heading">
                    <h2>
                        <span className="red">Red Wolf</span> <span className="ev">Products</span>
                    </h2>
                </div>

                <div className="features-container">
                    {features.map((feature, index) => (
                        <FeatureCard
                            key={index}
                            image={feature.image}
                            title={feature.title}
                            description={feature.description}
                            highlight={index % 2 === 0} // Highlight only 0, 2, 4
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;
